export default "__VITE_ASSET__Bi4Xnj65__"